import React, { useRef,useState } from 'react';
import Form, { Item } from 'devextreme-react/form';
import { Button } from 'devextreme-react';

import uri from '../../utils/uri';
import Title from '../../components/shared/Title';
import { formatDateTime } from '../../data/app';
import BlockHeader from '../../components/shared/BlockHeader';
import { useEffect } from 'react';
import http from '../../utils/http';

const SMSCredits = props => {
  
    let dataGrid = useRef();
    const [ data, setData ] = useState({});
    const [ loading, setLoaging ] = useState(true);

    const title = "Creditos de sms";

    useEffect(() => {

        const getData = async () => {
            const data = await http(uri.sms.get + '/credits').asGet();
            setData(JSON.parse(data));
            setLoaging(false);
        }

        getData();
        
    }, [0]);

    return (
        <div className='container small'>
            <Title title={title} />
            <BlockHeader title={title}/> 
            {loading && <div>Cargando...</div>}
            {!loading && <div>
                <Form
                    readOnly={true}
                    colCount={1}
                    id="form"
                    formData={data}>
                        <Item dataField="id" />
                        <Item dataField="company.name" caption='Empresa' />
                        <Item dataField="site" />
                        <Item dataField="username" />
                        <Item dataField="credits.balance" caption='Creditos'/>
                        <Item dataField="quota.remaining" caption='Disponible'  />
                </Form>
                <br/>
                <Button
                    width={180}
                    text={'Configurar aviso'} 
                    type="normal"
                    icon='print'
                    onClick={() => {

                        props.history.push('/clinica/app' )

                    }}
                />
            </div>}
        </div>
    );
}

export default SMSCredits;
